import React, {Dispatch, SetStateAction} from "react";

interface ServiceContextType {
    contentLoading: boolean,
    setContentLoading: Dispatch<SetStateAction<boolean>>,
}
export const Context = React.createContext<ServiceContextType | undefined>(undefined)
